import './assets/scss/app.scss'

import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7'
import React, { Suspense } from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router'
import { Slide, ToastContainer } from 'react-toastify'

import AppRoutes from './AppRoutes'
import { GlobalSpinner } from './components/misc/GlobalSpinner'
import { SentryErrorBoundary } from './components/misc/SentryErrorBoundary'
import SessionProvider from './components/providers/SessionProvider'
import { queryClient } from './lib/queryClient'
import { store } from './store/store'

export const App: React.FC = () => (
  <SentryErrorBoundary>
    <HelmetProvider>
      <NuqsAdapter>
        <Provider store={store}>
          <Helmet titleTemplate="%s | CPad" defaultTitle="CPad" />
          <QueryClientProvider client={queryClient}>
            <ReactQueryDevtools buttonPosition="bottom-left" />

            <Suspense fallback={<GlobalSpinner />}>
              <SessionProvider>
                <BrowserRouter>
                  <AppRoutes />
                </BrowserRouter>
              </SessionProvider>
            </Suspense>

            <ToastContainer
              hideProgressBar
              theme="colored"
              transition={Slide}
            />
          </QueryClientProvider>
        </Provider>
      </NuqsAdapter>
    </HelmetProvider>
  </SentryErrorBoundary>
)
